import { createUseStyles } from 'react-jss';

interface StyleProps {
  columnsValue: number;
}

export const useStyles = createUseStyles<string, StyleProps>((theme: any) => ({
  blockWrapper:({ columnsValue }: StyleProps) => ({
    margin: 10,
    width: `calc(100% / ${columnsValue || 4} - 20px)`,
    overflow: 'hidden',
    position: 'relative',
    borderRadius: 10,
    aspectRatio: 1,
    "& img": {
      borderRadius: 10,
    },
    
  }),
  imageWrapper: {
    position: 'relative',
    borderRadius: 10,
    aspectRatio: 1,
    overflow: 'hidden',
    flex: 1,
    backgroundColor: theme.palette.action.hover, // #f9f9f9 -> action.hover
    "& img": {
      borderRadius: 10,
    }
  },
  addedToCart: {
    width: 24,
    height: 24,
    backgroundColor: "#FF9800",
    color: "white",
    textAlign: 'center',
    padding:' 0 0px',
    borderRadius: 5,
    margin: 5,
    marginRight: 0,
    cursor: 'help'
  },
  ordered: {
    width: 24,
    height: 24,
    backgroundColor: "green",
    color: "white",
    textAlign: 'center',
    padding:' 0 0px',
    borderRadius: 5,
    margin: 5,
    cursor: 'help'
  },
  itemNav:{
    position: "absolute",
    left: 5,
    top: 5,
    height: "auto",
    width: '100%',
    display: "flex",
    color: theme.palette.text.primary,
  },
  itemNavBottom:{
    position: "absolute",
    left: 5,
    bottom: 5,
    width: "100%",
    display: 'flex',
    justifyContent: 'flex-end',
    color: theme.palette.text.primary,
  },
  popUp:{
    position:"absolute",
    width: '100%',
    height: '100%',
    display: "flex",
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10,
    left: 0,
    top: 0,
    backgroundColor: 'rgba(0,0,0,0.67)'
  },
  popUpWrap:{
    width: '80%',
    maxHeight: "80%",
    height: '80%',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 10,
    left: 0,
    right: 0,
    padding: 10,
    position:"relative",
    color: theme.palette.text.primary,
  },
  contentWrapper: {
    height: "85%",
    maxHeight: "85%",
    overflow:"scroll",
    width: '100%'
  },
  popUpBox:{
    display: "flex",
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 10,
    "& img":{
      maxWidth: '33%',
      height: 'auto',
      maxHeight: 400,
    }

  },
  popUpClose:{
    position: "absolute",
    width: '35px',
    height: '35px',
    right: -15,
    top:-15,
    zIndex: 11,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    cursor: "pointer",
    borderRadius: 20,
    paddingTop: '4px',
    fontWeight: 900,
    textAlign: 'center',
    border: `1px solid ${theme.palette.divider}`,
  },

  ///NEW ONE
  editButton: {
    padding:[8, 20],
    width: 'fit-content',
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    cursor:'pointer',
    fontWeight: 600,
    borderRadius: 5,
    height: "40px",
    margin: '10px 10px',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    }
  },
  cancelButton: {
    padding:[8, 30],
    width: 'fit-content',
    backgroundColor: '#ff0000',
    color: 'white',
    cursor:'pointer',
    fontWeight: 600,
    borderRadius: 5,
    height: "40px",
    margin: '10px 10px',
    '&:hover': {
      backgroundColor: '#c00707',
    }
  },
  holdButton:{
    padding:[8, 30],
    width: 'fit-content',
    backgroundColor: '#40f8f8',
    color: 'black',
    cursor:'pointer',
    fontWeight: 600,
    borderRadius: 5,
    height: "40px",
    margin: '10px 10px',
    '&:hover': {
      backgroundColor: '#2eafaf',
    }
  },
  popUpShort: {
    display: "flex",
    margin: '0 auto',
    width: 'fit-content',
    '& span': {
      display: "block",
      margin: [5,25],
      fontWeight: 600
    }
  },
  loader: {
    position: 'absolute',
    border: `10px solid ${theme.palette.action.hover}`, /* Світлий фон */
    borderTop: `10px solid ${theme.palette.primary.main}`, /* Синя частина */
    borderRadius: '50%',
    width: '50px',
    height: '50px',
    animation: '$spinNew 1s linear infinite', /* Додавання анімації */
  },

  '@keyframes spinNew': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    }
  }
}));
